import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { mockComponent } from 'react-dom/test-utils';
import moment from 'moment';

// not like to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

const sfcscDomain = process.env['REACT_APP_SFCSC_DOMAIN'];

i18n
  // load translation using xhr -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    //lng: 'en',
    fallbackLng: 'EN',
    whitelist: ['EN','TC'],
    //preload: ['EN','TC'],
    defaultNS: 'common',
    ns: [
      "common",
      "circular",
      "news",
      "consultation",
    ],
    interpolation: {
        escapeValue: true, // not needed for react as it escapes by default
        format(value, format, locale) {
          if ( value instanceof Date ) {
            //let moment = require('moment');
            moment.locale(locale);
            const text =  moment(value).format(format);
            return text;
          } else {
            return value;
          }
        }
    },
    backend: {
      //for backend configuration options:
      //https://github.com/i18next/i18next-xhr-backend
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
    },
    detection: {
      order: ['path'],
      lookupFromPathIndex: (window.location.hostname === sfcscDomain?4:2),
      caches: false
    },
    react: {
      useSuspense: true
    }
  });


export default i18n;